import { createSlice } from '@reduxjs/toolkit'
import { service } from '../shared/_services/api_service'
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  enotesSubjectData: [],
  totalenotesSubject: 0,
  isOpenModal: false,
}

export const enotesSubjectSlice = createSlice({
  name: "enotesSubject",
  initialState,
  reducers: {
    setenotesSubjectData(state, { payload }) {
      state.enotesSubjectData = payload.result
      state.totalenotesSubject = payload.count
    },
    updateenotesSubjectData(state, { payload }) {
      const objIndex = state.enotesSubjectData.findIndex((obj) => obj._id === payload._id);
      if (objIndex >= 0) {
        state.enotesSubjectData[objIndex] = payload
      }
    },
    deleteenotesSubjectData(state, { payload }) {
      const objIndex = state.enotesSubjectData.findIndex((obj) => obj._id === payload);
      if (objIndex >= 0) {
        state.enotesSubjectData.splice(objIndex, 1)
        state.totalenotesSubject -= 1
      }
    },
    pushenotesSubjectData(state, { payload }) {
      state.enotesSubjectData.push(payload)
      state.totalenotesSubject += 1
    },

    isOpenModal(state, { payload }) {
      state.isOpenModal = payload
    },
    ModalToggle(state, { payload }) {
      state.isOpenModal = !state.isOpenModal
    },
  }
})

export const { setenotesSubjectData, updateenotesSubjectData, deleteenotesSubjectData, pushenotesSubjectData, isOpenModal,
  ModalToggle } = enotesSubjectSlice.actions;

export default enotesSubjectSlice.reducer;

export function getenotesSubject(limit, offset,) {
  return async function getenotesSubjectThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getenotesSubject(limit, offset, ).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setenotesSubjectData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function addenotesSubject(payload) {
  return async function addenotesSubjectThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.addenotesSubject(payload).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(pushenotesSubjectData(response.data))
          successHandler('Added Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updateenotesSubject(id, title) {
  return async function updateenotesSubjectThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updateenotesSubject(id, title).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(updateenotesSubjectData(response.data))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}


export function statusDeleteenotesSubject(id) {
  return async function statuseleteenotesSubjectThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      await service.deleteenotesSubject(id).then(
        (response) => {
          dispatch(deleteenotesSubjectData(id))
          dispatch(setLoading(false))
          successHandler('Deleted Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}



